export default __webpack_public_path__ + "img/download.90a7d2dc.svg";